import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
import { useRouter } from 'next/router';
import EcoSpace from 'eco-design/base/eco-space';

const R: React.FC = () => {
    const { useLang } = useGlobal();
    const { t } = useLang('powerbackup.R');
    return (
        <>
            <div
                id="power-backup-R "
                className={`power-backup-R ${css['power-backup-R']} GtmModuleData-section`}
                data-section-id={'powerPreparedness-R'}
                data-section-title={t('secR_title1')}
            >
                <div className="footer-disclaimer page-layout">
                    <div className="">
                        <p>{t('secR_title1')}</p>
                        <p>{t('secR_title2')}</p>
                        <p>{t('secR_title3')}</p>
                    </div>
                </div>
            </div>
            <EcoSpace />
        </>
    );
};

export default R;
